module.exports = __webpack_public_path__ + "static/img/logoLogin.9d16652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoLogin.png
// module id = 205
// module chunks = 10